// Consist of commonly used validation
import MotorValidations from './motor'
import FireValidations from './fire'
import MaidValidations from './maid'
import GeneralValidations from './general'
import PkgValidations from './pkg'
import CargoValidations from './cargo'

const mavValidations = {
  install(Vue, options) {
    GeneralValidations()
    MotorValidations()
    FireValidations()
    PkgValidations()
    MaidValidations()
    CargoValidations()
  }
}

export default mavValidations
